var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "39px",
    viewBox: "0 0 32 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-913.000000, -546.000000)",
    fill: "#FF006E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M940.306662,573.306662 L928.999998,584.613325 L917.693335,573.306662 C915.631103,571.268138 914.24445,568.850377 913.533336,566.053334 C912.822221,563.351096 912.822221,560.648895 913.533336,557.94667 C914.24445,555.149614 915.625177,552.725941 917.675557,550.675552 C919.725937,548.625176 922.149611,547.244446 924.946666,546.533339 C927.648904,545.82222 930.351093,545.82222 933.05333,546.533339 C935.850386,547.244446 938.274059,548.625176 940.324436,550.675552 C942.374824,552.725941 943.755542,555.149614 944.466661,557.94667 C945.17778,560.648895 945.17778,563.351096 944.466661,566.053334 C943.755542,568.850377 942.3689,571.268138 940.306662,573.306662 Z M928.999998,565.555548 C929.971859,565.555548 930.807406,565.205926 931.506664,564.506668 C932.205922,563.807398 932.555557,562.971851 932.555557,562.000002 C932.555557,561.028141 932.205922,560.192594 931.506664,559.493336 C930.807406,558.794066 929.971859,558.444443 928.999998,558.444443 C928.028137,558.444443 927.19259,558.794066 926.493332,559.493336 C925.794074,560.192594 925.44444,561.028141 925.44444,562.000002 C925.44444,562.971851 925.794074,563.807398 926.493332,564.506668 C927.19259,565.205926 928.028137,565.555548 928.999998,565.555548 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleTypeIcon);
export default __webpack_public_path__ + "static/media/purple_type_icon.7241e3be2a9c50d10be2d92508e30cc2.svg";
export { ForwardRef as ReactComponent };